<template>
  <vx-card class="mt-base" :title="activityTitle">
    <p class="mb-5">
      One of the best ways to plan a game in the early stages is to storyboard it. A storyboard is a
      sequence of drawings that provides an outline of the game. Each frame is used to represent
      different levels, scenes, or goals. Usually, there’ll be a paragraph or two providing a little
      more detail and explanation accompanying the frames.
    </p>
    <p class="mb-5">
      Enough chit-chat! The best way to understand how a video game storyboard works is to take a
      look at one.
    </p>
    <p class="mb-5 italic">Storyboard Example 1:</p>
    <p class="mb-5">
      Here’s a sample storyboard for a basic shoot ‘em up style arcade game - somewhat similar to
      the one you’ll make yourself later in this virtual work experience.
    </p>
    <p class="mb-5">
      Notice how there are six frames, with each of the frames representing a different game level,
      with the final frame representing the game’s overall goal. Notice too that this storyboard is
      sketched by hand and a little messy! Storyboards are really for brainstorming. Getting your
      ideas down is the priority, not creating a beautiful work of art!
    </p>

    <centered-image-wrapper
      :image="image1"
      classes="2/3"
      alt="Hand-drawn six-frame storyboard for a space shoot 'em up game. Frame 1: the player's ship leaves a planet through a wormhole. Frame 2: the player dodges falling asteroids. Frame 3: enemy ships attack the player. Frame 4: a two-minute wave with black holes while the player has weak shields. Frame 5: power-ups and damage from structures, with 360-degree control. Frame 6: a large boss ship with marked damage points and weapons."
    />

    <p class="mb-5">
      However, sketching out your storyboard by hand isn’t the only option. You could also use
      software such as “StoryboardThat” to create your storyboard.
    </p>
    <p class="mb-5">
      To get started, first watch the short tutorial that explains the main functions of
      StoryboardThat.
    </p>

    <responsive-youtube-wrapper :video="videos[1].video" :image="videos[1].image" />

    <p class="mb-5 italic">Storyboard Example 2:</p>
    <p class="mb-5">Here’s a sample video game storyboard created using “StoryboardThat”.</p>

    <centered-image-wrapper
      :image="image3"
      classes="2/3"
      alt="Six-frame storyboard made in StoryboardThat for a game called Crusades O'Rama. Frame 1: choose your character, a knight (X button) or a robed figure (O button), outside a castle. Frame 2: cut scene, see the Pope's call for Crusade: 'Go reclaim the Holy Land and you will be saved!'. Frame 3: must collect water to survive travel to the Holy Land. Frame 4: Battle for Antioch, defeat enemies. Frame 5: Battle of Jerusalem, breach the walls. Frame 6: Massacre in Jerusalem, must save 10 civilians."
    />

    <p class="mb-5">
      You can create a free trial account with “StoryboardThat”, which allows you to try out the
      programme. It limits you to two 3-frame storyboards per week, which means you could plan out a
      6-frame storyboard this week using the free account. You can save your work and either
      screenshot your work or download it - though the download will contain a watermark.
    </p>

    <h4 class="mb-5">Your Task: Create Your Storyboard</h4>

    <p class="mb-5">
      Now you have two options to create your storyboard, either by hand or using the StoryboardThat
      software.
    </p>

    <p class="mb-5">
      Decide which you want to use and get going! When you have completed your 6-frame storyboard,
    </p>
    <h4 class="mb-5">Either:</h4>
    <p class="mb-5">1. Download your samples from “StoryboardThat” and upload your work here</p>
    <h4 class="mb-5">Or:</h4>
    <p class="mb-5">2. Take a photograph of your sketched storyboard and upload it here</p>

    <fileupload-button-immediate
      v-model="uploaded_files['uploaded_file_1']"
      :is-editable="isEditable"
      index="1"
      filetype="photo_doc"
      upload-btn-text="Upload Storyboard"
    />

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';

export default {
  data() {
    return {
      videos: {
        1: {
          image: require('@/assets/images/experiences/gamesdeveloper/storyboard_that_splash.jpg'),
          video: 'https://www.youtube.com/embed/xkgNAMDL_sM',
        },
      },
      image1: require('@/assets/images/experiences/gamesdeveloper/sample_storyboard_1.jpg'),
      image2: require('@/assets/images/experiences/gamesdeveloper/storyboard_that_splash.jpg'),
      image3: require('@/assets/images/experiences/gamesdeveloper/sample_storyboard_2.png'),

      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
